export enum DisplayStatus {
  Draft = 'Draft',
  Published = 'Published',
  Internal = 'Internal',
  Public = 'Public',
  PublicSSO = 'Public SSO',
  AwaitingPublishApproval = 'Awaiting Publish Approval'
}
